import { CanDeactivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { UserProfileComponent } from '../../user-profile/user-profile.component';
import { LookupService } from '../lookups/lookup.service';
import { AuthUserService } from '../appInitialization/authUser.service';

@Injectable()
export class HasLocationsGuard implements CanDeactivate<UserProfileComponent> {

  private _locations: Location[];

  constructor(private lookupService : LookupService) {}

  canDeactivate(): Promise<boolean> {
    return this.lookupService.getUserLocations().toPromise()
                      .then((locations: Location[]) => {
                        return this._locations = locations;
                      })
                      .then(() => {
                        return (this._locations != null && this._locations.length != 0);
                      });

  }

}




